import { render, staticRenderFns } from "./dialog-actionbar.vue?vue&type=template&id=85e48cc0&scoped=true"
import script from "./dialog-actionbar.vue?vue&type=script&lang=js"
export * from "./dialog-actionbar.vue?vue&type=script&lang=js"
import style0 from "./dialog-actionbar.vue?vue&type=style&index=0&id=85e48cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e48cc0",
  null
  
)

export default component.exports